import React from 'react'
import { createRoot } from 'react-dom/client'
import './application.css'
import LandingApp from '@/apps/landing'
import { camelizeObject } from '@/utils/camelize-props'

const container = document.getElementById('root')
const root = createRoot(container!)
const props = camelizeObject(JSON.parse(container?.dataset.props || '{}'))
const brokerPortalEnabled = props.brokerPortalEnabled === true

root.render(
  <React.StrictMode>
    <LandingApp brokerPortalEnabled={brokerPortalEnabled} />
  </React.StrictMode>
)
